import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone, MessageCircle, Mail, Clock, MapPin } from "lucide-react";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { siteInfo } from "../data/mock";

const RichiediInfo = () => {
  const whatsappUrl = `${siteInfo.socials.whatsapp}?text=${encodeURIComponent("Ciao, vorrei informazioni sui vostri corsi")}`;

  return (
    <div className="py-16 md:py-24 bg-[#fafaf7] min-h-[85vh]">
      <div className="max-w-3xl mx-auto px-6">
        <Link to="/" className="inline-flex items-center gap-2 text-brand hover:text-brand-dark text-sm font-semibold mb-10">
          <ArrowLeft className="w-4 h-4" /> Torna alla home
        </Link>

        <div className="text-center mb-12">
          <Badge className="bg-brand-light text-brand hover:bg-brand-light mb-4 border-0">
            <Phone className="w-3 h-3 mr-1.5" /> Contattaci direttamente
          </Badge>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-brand-dark mb-4 leading-tight">
            Chiamaci per <span className="italic text-brand">informazioni</span>
          </h1>
          <p className="text-lg text-brand-dark/70 max-w-xl mx-auto">
            Un nostro operatore risponderà alle tue domande su corsi, costi, date e iscrizioni.
          </p>
        </div>

        {/* Big phone card */}
        <a href={`tel:${siteInfo.phone}`} className="block group">
          <div className="bg-brand text-white rounded-3xl p-10 md:p-14 shadow-2xl overflow-hidden relative hover:shadow-emerald-900/40 transition-shadow">
            <div className="absolute inset-0 bg-dots-pattern opacity-20"></div>
            <div className="absolute -top-20 -right-20 w-72 h-72 bg-emerald-500/20 rounded-full blur-3xl"></div>

            <div className="relative flex flex-col items-center text-center">
              <div className="w-20 h-20 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center mb-6 animate-pulse-ring">
                <Phone className="w-9 h-9" />
              </div>
              <div className="text-sm uppercase tracking-[0.2em] text-emerald-200 font-semibold mb-3">Numero verde</div>
              <div className="font-display text-4xl md:text-6xl font-bold tracking-tight mb-4 group-hover:scale-105 transition-transform">
                {siteInfo.phone}
              </div>
              <p className="text-emerald-100/90 text-base max-w-md">
                Clicca per chiamare direttamente dal tuo telefono
              </p>
            </div>
          </div>
        </a>

        {/* Alternative contacts */}
        <div className="grid md:grid-cols-2 gap-4 mt-6">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-white rounded-2xl p-6 border border-emerald-100 hover:border-brand hover:shadow-lg hover:-translate-y-0.5 transition-all group"
          >
            <div className="w-14 h-14 rounded-2xl bg-[#25D366]/10 text-[#25D366] flex items-center justify-center flex-shrink-0 group-hover:bg-[#25D366] group-hover:text-white transition-colors">
              <MessageCircle className="w-7 h-7" fill="currentColor" strokeWidth={0} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-wider text-brand-dark/60 font-semibold mb-1">WhatsApp</div>
              <div className="font-bold text-brand-dark">Scrivi su WhatsApp</div>
              <div className="text-xs text-brand-dark/60 mt-0.5">Risposta rapida</div>
            </div>
          </a>

          <a
            href={`mailto:${siteInfo.email}`}
            className="flex items-center gap-4 bg-white rounded-2xl p-6 border border-emerald-100 hover:border-brand hover:shadow-lg hover:-translate-y-0.5 transition-all group"
          >
            <div className="w-14 h-14 rounded-2xl bg-brand-light text-brand flex items-center justify-center flex-shrink-0 group-hover:bg-brand group-hover:text-white transition-colors">
              <Mail className="w-7 h-7" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-wider text-brand-dark/60 font-semibold mb-1">Email</div>
              <div className="font-bold text-brand-dark break-all text-sm">{siteInfo.email}</div>
              <div className="text-xs text-brand-dark/60 mt-0.5">Risposta entro 24h</div>
            </div>
          </a>
        </div>

        {/* Info strip */}
        <div className="mt-10 bg-white rounded-2xl p-6 border border-emerald-100 flex flex-col sm:flex-row items-center justify-around gap-4 text-sm">
          <div className="flex items-center gap-2 text-brand-dark">
            <Clock className="w-4 h-4 text-brand" />
            <span><strong>Orari:</strong> Lun-Ven 9:00 - 18:00</span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-emerald-100"></div>
          <div className="flex items-center gap-2 text-brand-dark">
            <MapPin className="w-4 h-4 text-brand" />
            <span><strong>Sede:</strong> {siteInfo.address}</span>
          </div>
        </div>

        <p className="text-center text-xs text-brand-dark/50 mt-8">
          Puoi anche usare il chatbot in basso a destra per informazioni rapide 24/7.
        </p>
      </div>
    </div>
  );
};

export default RichiediInfo;
